import { SxProps, Theme } from "@mui/material";
import React, { ReactElement, ReactNode } from "react";
import { Control, Controller, FieldValues, Path, RegisterOptions, UseFormReturn } from "react-hook-form";
import { FileUploadButton } from "../Inputs/FileUploadButton";

interface FormFileUploadButtonProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  fieldName: Path<T>;

  label: ReactNode;
  startIcon?: ReactNode;
  helperText?: ReactNode;
  dropAreaNote?: string;
  linkToFileNote?: string;
  validation?: RegisterOptions;

  accept?: string;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
  variant?: "text" | "contained" | "outlined";
  fullWidth?: boolean;
  sx?: { button?: SxProps<Theme> };
}

export const FormFileUploadButton = <T extends FieldValues>(
  props: FormFileUploadButtonProps<T>
): ReactElement | null => {
  const {
    form,
    fieldName,
    label,
    startIcon,
    helperText,
    dropAreaNote,
    linkToFileNote,
    validation,
    accept,
    disabled,
    size,
    variant,
    fullWidth,
    sx,
  } = props;

  return (
    <Controller
      name={fieldName}
      control={form.control as Control<FieldValues>}
      rules={validation}
      render={({ field, fieldState }) => {
        const { value, onChange } = field;
        const { error } = fieldState;

        return (
          <FileUploadButton
            label={label}
            value={value}
            onChange={onChange}
            startIcon={startIcon}
            error={!!error}
            helperText={error?.message || helperText}
            dropAreaNote={dropAreaNote}
            linkToFileNote={linkToFileNote}
            accept={accept}
            required={!!validation?.required}
            disabled={disabled}
            size={size}
            variant={variant}
            fullWidth={fullWidth}
            sx={sx}
          />
        );
      }}
    />
  );
};
